import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { useConsent } from "@/context/ConsentContext";
import {
  buildGeneralMessage,
  buildServiceMessage,
  buildWhatsAppUrl,
  trackWhatsAppClick,
} from "@/lib/whatsapp";
import { cn } from "@/lib/utils";
import { WhatsAppIcon } from "./WhatsAppIcon";

// Reusable WhatsApp CTA. Builds the correct prefilled message for the active
// language + service, and logs the click only when analytics consent is given.
export function WhatsAppButton({
  serviceKey = "general",
  source = "unknown",
  variant = "default",
  size = "lg",
  className,
  children,
  testId,
}) {
  const { lang } = useLanguage();
  const { analyticsAllowed } = useConsent();

  const message =
    serviceKey === "general"
      ? buildGeneralMessage(lang)
      : buildServiceMessage(lang, serviceKey);
  const href = buildWhatsAppUrl(message);

  const handleClick = () => {
    if (analyticsAllowed) {
      trackWhatsAppClick({ serviceKey, lang, source });
    }
  };

  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={cn("font-semibold", className)}
    >
      <a
        href={href}
        onClick={handleClick}
        data-testid={testId}
        aria-label="WhatsApp"
      >
        <WhatsAppIcon className="h-[1.1em] w-[1.1em]" />
        {children}
      </a>
    </Button>
  );
}
